<!-- 学习园地 -->
<template>
    <div class="business-content-main">
        <breadcrumb></breadcrumb>
        <el-container style="height: 650px" v-loading="loading">
            <el-container style="height: 100%;margin-top: 20px;">
                <el-aside :width="isShrink ? '0' : '16%'" height="100%" style="transition: all 0.3s">
                    <el-card class="box-card" style="padding: 20px; height: 100%; overflow: auto">
                        <el-row>
                            <el-col :span="24">
                                <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                            </el-col>
                        </el-row>
                        <el-tree highlight-current :expand-on-click-node="false" default-expand-all :data="searchData"
                            ref="tree" :filter-node-method="filterNode" node-key="Id" :props="treeProps" show-checkbox
                            :check-strictly="true" @node-click="handleNodeClick" @check="handleNodeCheck">
                                <template #default="{ data, node }">
                                    <el-tooltip 
                                        effect="dark" 
                                        :content="data.Name"
                                        placement="top"
                                    >
                                        <span>{{ data.Name }}</span>
                                    </el-tooltip>
                                </template>
                        </el-tree>
                    </el-card>
                </el-aside>

                <!-- <div class="shrink-out-view" @click="changeShrink">
                    <div class="shrink-in-view"><i class="el-icon-arrow-right" :class="{ active: !isShrink }"></i></div>
                </div> -->

                <el-main :width="isShrink ? '0' : '84%'" height="100%" style="padding-top: 0px; transition: all 0.3s"
                    v-if="!isEditTree">
                    <el-card class="box-card" style="padding: 20px 30px; height: 100%;overflow: auto;">
                        <!--这里有3个页面，初始获取这个节点是否有多个内容，多个展示内容标题列，单个直接进入内容详细，然后是新增编辑页面，删除要进入详细或编辑页才可以-->
                        <div v-if="!isEditContent">
                            <!-- 通过内容集合的Id是否为空判断是否详细页面 -->
                            <template v-if="contformData.Id == ''">
                                <div class="row" v-for="item in contentList" :key="item.Id">
                                    <div class="item-li"> </div>
                                    <div class="item-cont" @click="getDetail(item.Id)">{{ item.Titile }}</div>
                                </div>
                            </template>

                            <template v-else>
                                <el-button class="btn-primary" size="small" @click="back">
                                    <i class="el-icon-back"></i>
                                </el-button>
                                <div class="flex-between" style="height: 30px;">
                                    <div class="titile">{{ contformData.Titile }}</div>
                                    <div>更新时间：{{ contformData.UpdateTime }}</div>
                                </div>
                                <div class="flex-between">
                                    <div></div>
                                    <div style="padding-right: 10rpx;color: #999999; ;">浏览数：{{ contformData.ViewCount }}</div>
                                </div>
                                <div class="ql-container ql-snow">
                                    <div class="ql-editor">
                                        <div v-html="contformData.Content"></div>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <template v-else>
                            <el-button class="btn-primary" style="margin-bottom: 20px;" size="small"
                                v-if="contentList.length > 1" @click="back">
                                <i class="el-icon-back"></i>
                            </el-button>
                            <el-form ref="form" :model="contformData" label-width="80px" :disabled="!isEdit">
                                <el-form-item label="标题">
                                    <el-input v-model="contformData.Titile"></el-input>
                                </el-form-item>
                                <el-form-item label="所属目录">
                                    <el-cascader style="width: 100%" :key="cascaderKey" v-model="contformData.ParentId"
                                        :options="searchData" :props="cascaderProps" clearable></el-cascader>
                                </el-form-item>
                                <el-form-item label="正文内容" style="height: 300px;">
                                    <quill-editor class="editor" v-model="contformData.Content" ref="myQuillEditor"
                                        :options="editorOption" :disabled="!isEdit" @change="onEditorChange($event)">
                                    </quill-editor>
                                </el-form-item>
                                <el-row>
                                    <el-col :span="2">
                                        <el-button class="btn-primary" size="medium"
                                            @click="editSGContent">提交</el-button>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </template>

                    </el-card>
                </el-main>
                <el-main :width="isShrink ? '0' : '84%'" height="100%" style="padding-top: 0px; transition: all 0.3s"
                    v-else>
                    <el-card class="box-card" style="padding: 50px; height: 100%">
                        <el-form ref="form" :model="treeformData" label-width="80px" :disabled="!isEdit">
                            <el-form-item label="教程目录">
                                <el-input v-model="treeformData.Name"></el-input>
                            </el-form-item>
                            <el-form-item label="所属模块">
                                <el-cascader style="width: 100%" :key="cascaderKey" v-model="treeformData.ParentId"
                                    :options="searchData" :props="cascaderProps" clearable></el-cascader>
                            </el-form-item>
                            <el-form-item label="排序">
                                <el-input v-model="treeformData.Sort"></el-input>
                            </el-form-item>
                            <el-row>
                                <el-col :span="2">
                                    <el-button class="btn-primary" size="medium"
                                        @click="editStudentsGardens">提交</el-button>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList" :z-index="99999" />
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
    name: '',
    components: { breadcrumb, quillEditor, ElImageViewer },
    data() {
        return {
            isEdit: false,
            contformData: {
                Id: '',
                Titile: '',
                ParentId: '',
                Content: '',
                ViewCount:0,
                UpdateTime: ''
            },
            treeformData: {
                Id: '',
                Name: '',
                ParentId: '',
                Sort: 0,
            },
            searchData: [],
            contentList: [],
            cascaderKey: 0, //key值改变了，cascader就会重新渲染,以防切换数据时报错
            checkChildrens: [],//记录一下选择的节点是否有子节点
            treeProps: {
                children: 'Childrens',
                label: 'Name'
            },
            cascaderProps: {
                emitPath: false,
                expandTrigger: 'hover',
                children: 'Childrens',
                label: 'Name',
                value: 'Id',
                checkStrictly: true
            },
            filterText: '',
            editorOption: {
                placeholder: '请输入内容'
            },
            permission: {},
            showViewer: false,
            srcList: [],
            loading: false,
            matchNodeIds: new Set(),
            isEditContent: false,
            isEditTree: false,
            isShrink: false // 是否收缩状态
        };
    },
    watch: {
        filterText(val) {

            this.matchNodeIds.clear();

            if (val) {
                this.markMatchNodes(this.searchData, val);
            }

            this.$refs.tree.filter(val);
        }
    },
    created() {
        this.getSGTree();
        this.permission = this.$util.getPermission('ecStudyGardens');
        let shrinkStu = this.$util.getLocalStorage('studyGardensShrinkStu');
        this.isShrink = shrinkStu * 1 === 1;
    },
    mounted() {
        ///查看大图
        window.handleImgClick = (img) => {
            this.srcList = [];
            const imgSrc = img.src;
            this.srcList.push(imgSrc); // 存储到组件数据中，供后续使用
            this.showViewer = true;
        };
    },
    computed: {},
    methods: {
        // 改变收缩状态
        changeShrink() {
            this.isShrink = !this.isShrink;
            let value = !this.isShrink ? 0 : 1;
            this.$util.setLocalStorage('studyGardensShrinkStu', value);
        },
        // 遍历所有节点，标记直接匹配的节点ID
        markMatchNodes(nodes, value) {
            if (!nodes || nodes.length === 0) return;

            nodes.forEach(node => {
                // 直接匹配：节点名称包含搜索关键词
                if (node.Name && node.Name.includes(value)) {
                    this.matchNodeIds.add(node.Id); // 记录匹配节点ID
                }

                // 不管当前节点是否匹配，都要检查所有子节点
                this.markMatchNodes(node.Childrens, value);
            });
        },
        // 核心：只保留“直接匹配节点”或“匹配节点的子节点”
        filterNode(value, data) {

            if (!value) return true;

            // 当前节点是直接匹配节点 保留
            if (this.matchNodeIds.has(data.Id)) {
                return true;
            }

            // 当前节点是某个匹配节点的子节点（递归检查父节点是否有匹配） 保留
            if (this.isChildOfMatchNode(data, this.searchData)) {
                return true;
            }

            return false;
        },

        // 递归检查当前节点是否是“匹配节点”的子孙节点
        isChildOfMatchNode(node, allNodes) {

            if (!node.ParentId) return false; // 无父节点，不是匹配节点的子节点

            // 遍历所有节点，找到当前节点的父节点
            for (const parentNode of this.flattenNodes(allNodes)) {
                if (parentNode.Id === node.ParentId) {
                    // 父节点是匹配节点 → 当前节点是子节点，返回true
                    if (this.matchNodeIds.has(parentNode.Id)) {
                        return true;
                    }
                    // 递归检查父节点的父节点（支持多级子节点）
                    return this.isChildOfMatchNode(parentNode, allNodes);
                }
            }

            return false;
        },
        // 将树形结构扁平化为一维数组（找父节点）
        flattenNodes(nodes) {
            let result = [];
            if (!nodes || nodes.length === 0) return result;

            nodes.forEach(node => {
                result.push(node); // 添加当前节点
                // 递归添加子节点
                if (node.Childrens) {
                    result = result.concat(this.flattenNodes(node.Childrens));
                }
            });

            return result;
        },
        //共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身
        handleNodeClick(data, node, VueComponent) {
            this.isEdit = false;
            if (data) {
                ++this.cascaderKey;

                this.$refs.tree.setCheckedKeys([data.Id]);
                if (this.isEditTree) {
                    this.treeformData = {
                        Id: data.Id,
                        ParentId: data.ParentId,
                        Name: data.Name,
                        Sort: data.Sort,
                    };
                    this.checkChildrens = data.Childrens;
                } else {
                    this.isEditContent = false;
                    this.getTreeTitleList(data.Id)
                }
            }
        },
        //共两个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象，包含 checkedNodes、checkedKeys、halfCheckedNodes、halfCheckedKeys 四个属性
        handleNodeCheck(data, checkData) {
            this.isEdit = false;
            this.$refs.tree.setCheckedKeys([data.Id]);
            if (checkData) {
                ++this.cascaderKey;
                if (this.isEditTree) {
                    this.treeformData = {
                        Id: data.Id,
                        ParentId: data.ParentId,
                        Name: data.Name,
                        Sort: data.Sort,
                    };
                    this.checkChildrens = data.Childrens;
                } else {
                    this.isEditContent = false;
                    this.getTreeTitleList(data.Id)
                }
            }
        },
        getSGTree() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetEntpStudentsGardensTree',
                    data: { Key: '' }
                })
                .then(res => {
                    ++this.cascaderKey;
                    if (res.data) {
                        this.searchData = this.getSearchData(res.data);
                        if (!this.isEditTree) {
                            var data = this.searchData[0];
                            this.getTreeTitleList(data.Id);
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        getSearchData(data) {
            for (var i = 0; i < data.length; i++) {

                if (!data[i].Childrens || data[i].Childrens.length < 1) {
                    data[i].Childrens = undefined;
                } else {
                    this.getSearchData(data[i].Childrens);
                }
            }
            return data;
        },
        getTreeTitleList(Id) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetStudentsGardensTitileList',
                    data: { Id: Id }
                })
                .then(res => {
                    if (res.errcode != 0) return;
                    if (res.data) {
                        var data = res.data;
                        this.contentList = data;
                        this.contformData = {
                            Id: '',
                            ParentId: '',
                            Titile: '',
                            Content: '',
                            UpdateTime: ''
                        };
                        this.isEditContent = false;
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        getDetail(Id) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetStudentsGardensDetail',
                    data: { Id: Id }
                })
                .then(res => {
                    if (res.errcode != 0) return;
                    if (res.data) {
                        var data = res.data;
                        if (data) {
                            const ct = data.Content.replace(
                                /<img src="([^"]+)"/g,
                                '<img src="$1" onclick="handleImgClick(this)" '
                            );
                            this.contformData = {
                                Id: data.Id,
                                ParentId: data.ParentId,
                                Titile: data.Titile,
                                Content: ct,
                                ViewCount: data.ViewCount,
                                UpdateTime: data.UpdateTime
                            };
                            this.isEditContent = false;
                        } else {
                            this.$util.warningMsg("没有找到数据，请刷新后重试！")
                        }
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        editStudentsGardens() {
            let that = this;

            if (!that.treeformData.Name) {
                this.$util.warningMsg('请输入目录名称');
                return false;
            }
            if (!that.treeformData.Sort && that.treeformData.Sort != 0) {
                this.$util.warningMsg('请输入排序');
                return false;
            }
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/EditStudentsGardens',
                    data: that.treeformData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.treeformData.Id = res.data;
                        that.isEdit = false;
                        that.$util.successMsg('保存成功');
                        that.getSGTree();
                    } else {
                        this.$util.errorMsg(res.errMsg);
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        editSGContent() {
            let that = this;

            if (!that.contformData.Titile) {
                this.$util.warningMsg('请输入内容标题');
                return false;
            }
            if (!that.contformData.ParentId) {
                this.$util.warningMsg('请选择所属节点');
                return false;
            }
            if (!that.contformData.Content) {
                this.$util.warningMsg('请输入内容');
                return false;
            }

            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/EditSGContent',
                    data: that.contformData
                })
                .then(res => {
                    if (res.errcode == 0) {
                        that.contformData.Id = res.data;
                        that.isEdit = false;
                        that.isEditContent = false;
                        that.$util.successMsg('保存成功');
                        that.getTreeTitleList(that.contformData.ParentId);
                    } else {
                        this.$util.errorMsg(res.errMsg);
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        delSG() {
            if (!this.treeformData.Id) {
                this.$util.warningMsg('请先选择要删除目录');
                return;
            }
            if (this.checkChildrens && this.checkChildrens.length > 0) {
                this.$util.warningMsg('还有下级目录，不可删除');
                return;
            }
            this.$confirm('一经删除无法恢复,是否确认删除？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.loading = true;
                    this.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DelStudentsGarden?Id=' + this.treeformData.Id
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.$util.successMsg('删除成功');
                                this.clearFormData();
                            }
                            this.getSGTree();
                        }).finally(() => {
                            this.loading = false;
                        });
                })
                .catch(action => { });
        },
        delSGCont() {
            if (!this.contformData.Id) {
                this.$util.warningMsg('请先选择要删除内容');
                return;
            }
            this.$confirm('一经删除无法恢复,是否确认删除？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            })
                .then(() => {
                    this.loading = true;
                    this.$util
                        .axiosGet({
                            url: '/api/EntpInfoManagement/DelSGContent?Id=' + this.contformData.Id + '&SGId=' + this.contformData.ParentId
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                this.$util.successMsg('删除成功');
                            }

                            //这里要父Id也就是内容的节点Id
                            this.getTreeTitleList(this.contformData.ParentId);
                        }).finally(() => {
                            this.loading = false;
                        });
                })
                .catch(action => { });
        },
        addFormData() {
            ++this.cascaderKey;
            this.clearFormData();
            this.isEdit = true;
        },
        editFormData() {
            if (this.isEditTree) {
                if (!this.treeformData.Id) {
                    this.$util.warningMsg('请先选择要编辑目录');
                    return;
                }
            }
            ++this.cascaderKey;
            this.isEdit = true;
            this.isEditContent = true;
        },
        gotoContent(item) {
            const ct = item.Content.replace(
                /<img src="([^"]+)"/g,
                '<img src="$1" onclick="handleImgClick(this)" '
            );

            this.contformData = {
                Id: item.Id,
                ParentId: item.ParentId,
                Titile: item.Titile,
                Content: ct,
                ViewCount: item.ViewCount,
                UpdateTime: item.UpdateTime
            };
            this.isEditContent = false;
        },
        clearFormData() {
            if (!this.isEditTree) {
                this.contformData = {
                    Id: '',
                    ParentId: '',
                    Titile: '',
                    Content: '',
                    UpdateTime: ''
                };
                this.isEditContent = true;
            } else {
                this.treeformData = {
                    Id: '',
                    ParentId: '',
                    Name: '',
                    Sort: 0
                };
            }
        },
        onEditorFocus(e) {
        },
        onEditorChange(e) {
        },
        back() {
            //内容详细页
            if (this.contformData.Id)
                this.contformData = {
                    Id: '',
                    ParentId: '',
                    Titile: '',
                    Content: '',
                    UpdateTime: ''
                };
            //添加编辑页
            if (this.isEditContent)
                this.isEditContent = false;
        },
        closeViewer() {
            this.showViewer = false;
        },
        switchView() {
            this.isEditTree = !this.isEditTree;
            this.isEdit = false;
            this.isEditContent = false;
            ++this.cascaderKey;

            ///切换内容和目录编辑页面重新赋值这一块
            if (this.isEditTree) {
                var data = this.contentList;
                if (data.length == 1) {
                    this.contformData = {
                        Id: data[0].Id,
                        ParentId: data[0].ParentId,
                        Titile: data[0].Titile,
                        Content: data[0].Content,
                        UpdateTime: data[0].UpdateTime
                    };
                } else {
                    this.contformData = {
                        Id: '',
                        ParentId: '',
                        Titile: '',
                        Content: '',
                        UpdateTime: ''
                    };
                }
                this.$refs.tree.setCheckedKeys([]);
            } else {
                this.treeformData = {
                    Id: '',
                    ParentId: '',
                    Name: '',
                    Sort: 0
                };
                ///内容的ParentId是tree的Id
                if (this.contformData.ParentId) {
                    this.$refs.tree.setCheckedKeys([this.contformData.ParentId]);
                }
                else
                    this.$refs.tree.setCheckedKeys([]);
            }
        }
    }
};
</script>
<style lang="less">
.business-content-main .el-card::-webkit-scrollbar {
    display: none;
}
</style>
<style lang="less" scoped>
.treeClass {
    width: auto;
    height: auto;
    border: cadetblue 1px solid;
    padding: 20px;
}

.shrink-out-view {
    background-color: rgba(0, 0, 0, 0.075);
    display: flex;
    align-items: center;
    cursor: pointer;
}

.shrink-in-view {
    width: 100%;
    height: 30px;
    background-color: #409eff;
    border-radius: 7px;
    text-align: center;
    display: flex;
    align-items: center;
    color: #fff;
}

.shrink-in-view .active {
    transform: rotate(-180deg);
}

.flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.row {
    width: 90%;
    height: 35px;
    border-radius: 5px;
    margin: 0;
    display: flex;
    align-items: center;
}

// .row{
//     width: 90%;
//     height: 40px;
//     border: 1px solid #efefef;
//     border-radius: 5px;
//     margin: 10px 0;
//     display: flex;
//     align-items: center;
// }
.item-li {
    width: 7px;
    height: 7px;
    margin-left: 10px;
    background-color: #000000;
}

.item-cont {
    width: 90%;
    height: 30px;
    margin: 20px;
    line-height: 30px;
    overflow: hidden;
}

.titile {
    font-weight: bold;
    font-size: 18px;
    margin: 10px 0;
}

.quill-editor {
    width: 100%;
    height: 240px;
    white-space: pre-wrap !important;
    /* 关键：保留连续空格，且自动换行 */
    word-spacing: normal !important;
    letter-spacing: 0 !important;
}

// .html-content {
//     white-space: pre-wrap !important;
// }

/deep/ .box-card img {
    max-width: 600px !important;
}

///默认样式影响到富文本的内容样式了
/deep/.box-card strong {
    font-weight: 700;
}

/deep/ .box-card em {
    font-style: italic !important;
}

.ql-container.ql-snow {
    border: none;
}
</style>
